import React from 'react';
import { timezone } from '../../pages/Account/icons';
import arrow from './arrow.svg';

type SelectProps = {
  children: JSX.Element[];
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  value: string | undefined;
  name?: string;
  size?: number;
};

export const Select: React.FC<SelectProps> = ({
  children,
  onChange,
  value,
  name,
  size,
}: SelectProps): JSX.Element => {
  return (
    <div className="select-container">
      <select
        size={size}
        value={value}
        name={name}
        onChange={onChange}
        className="select"
      >
        {children}
      </select>
      <img src={arrow} alt="Arrow" className="select-container__imgArrow" />
      {name === 'timezone' ? (
        <img src={timezone} alt="tz" className="select-container__iconTZ" />
      ) : (
        <></>
      )}
    </div>
  );
};
